import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import HomePage from './pages/HomePage';

ReactDOM.render(
  <React.StrictMode>
    <HomePage />
  </React.StrictMode>,
  document.getElementById('root'),
);
